// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3QjrT","footer":"Form_footer__24mZK"};